import { render, staticRenderFns } from "./MersTerms.vue?vue&type=template&id=104f57d1"
import script from "./MersTerms.vue?vue&type=script&lang=js"
export * from "./MersTerms.vue?vue&type=script&lang=js"
import style0 from "./MersTerms.vue?vue&type=style&index=0&id=104f57d1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports